type Props = {
  title: string;
  children: React.ReactNode;
};

export default function ChartCard({ title, children }: Props) {
  return (
     <div className="rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 shadow-sm">
      <h3 className="mb-4 text-base sm:text-lg font-semibold text-gray-900">
        {title}
      </h3>

      <div className="relative h-[240px] sm:h-[300px] lg:h-[360px]">
        {children}
      </div>
    </div>
  );
}
